import styled from 'styled-components';
import ds, { media } from 'designsystem';

const LanguagesWrapper = styled.div`
  display: flex;

  ${media.desktop`
    position: absolute;
    top: ${ds.get('navSection.navHeight')};
    display: block;
    transition-duration: 0.1s;
    opacity: ${({ visible }) => (visible ? '1' : '0')};
    pointer-events: ${({ visible }) => (visible ? 'inherit' : 'none')};
  `}
`;

export default LanguagesWrapper;



// WEBPACK FOOTER //
// ./src/blocks/Navigation/Languages/LanguagesWrapper.jsx